<template>
  <div class="footer_btn">
    <slot></slot>
    <template v-for="btn in btnAuth">
      <el-button
        :key="btn.code"
        slot="reference"
        size="mini"
        :type="btn.type || 'primary'"
        :disabled="btnDsb && btn.code != 'back'"
        v-if="!btn.isShow"
        :style="{
          backgroundColor: btn.color,
          border: btn.border || 'none',
          margin: btn.margin || '0 6px',
        }"
        @click="actionHandler(btn.code, btn)"
        class="footer-btn"
      >
        <i v-if="nowCode == btn.code && btnDsb" class="el-icon-loading"></i>
        <span v-if="btn.code != 'edit'">{{ btn.name }}</span>
        <span v-else>{{ isEdit ? "保存" : btn.name }}</span>
      </el-button>
    </template>
  </div>
</template>
<script>
export default {
  name: "JjFormFootBtn",
  components: {},
  props: {
    btnAuth: { type: Array, default: () => [] },
    btnDsb: { type: Boolean, default: false },
    isAdd: { type: Boolean, default: false },
  },
  data() {
    return {
      nowCode: "",
      isEdit: false,
    };
  },
  created() {
    if (this.isAdd) {
      this.btnAuth.map((it) => {
        if (it.code == "submit") {
          it.isShow = true;
        }
      });
    }
  },
  mounted() {},
  computed: {},
  methods: {
    // 按钮点击
    actionHandler(code, item) {
      this.nowCode = code;
      let key = code;
      item.dsb = this.btnDsb;
      if (code === "cancel") {
        item.isShow = true;
        this.setSaveBtn("cancel");
      }

      if (code == "edit") {
        key = this.isEdit ? "save" : code;
        this.setSaveBtn("edit");
      }
      this.$emit("actionHandler", key, item);
    },
    setSaveBtn(code) {
      this.isEdit = code === "cancel" ? false : !this.isEdit;
      this.btnAuth.map((it) => {
        if (code === "edit" && (it.code == "submit" || it.code == "cancel")) {
          it.isShow = !it.isShow;
        }

        if (code === "cancel" && it.code == "submit") it.isShow = false;
      });
    },
  },
  watch: {},
};
</script>
<style scoped lang="scss">
.footer_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  // box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  // margin-top: 15px;
  // border-radius: 8px 8px 0 0;
  flex-wrap: wrap;
  gap: 8px;
}

.footer-btn {
  min-width: 80px;
  padding: 6px 15px !important;
  font-size: 14px !important;
  border-radius: 4px !important;
  transition: all 0.2s ease !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12) !important;
  }

  &:active {
    transform: translateY(0);
  }

  i {
    font-size: 14px !important;
  }
}

// 特殊按钮样式
// ::v-deep .el-button--primary {
//   background-color: #165dff !important;
  
//   &:hover {
//     background-color: #0e4cca !important;
//   }
// }

// ::v-deep .el-button--warning {
//   background-color: #faad14 !important;
//   border-color: #faad14 !important;
  
//   &:hover {
//     background-color: #e69c00 !important;
//   }
// }

// ::v-deep .el-button--danger {
//   background-color: #ff4d4f !important;
//   border-color: #ff4d4f !important;
  
//   &:hover {
//     background-color: #f5222d !important;
//   }
// }

// ::v-deep .el-button--default {
//   background-color: #f5f5f5 !important;
//   color: #666 !important;
//   border: 1px solid #d9d9d9 !important;
  
//   &:hover {
//     background-color: #e6e6e6 !important;
//     color: #333 !important;
//   }
// }

// 加载状态样式
::v-deep .el-icon-loading {
  animation: rotate 1.5s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .footer_btn {
    padding: 10px;
    justify-content: flex-start;
    overflow-x: auto;
    gap: 6px;
    -webkit-overflow-scrolling: touch;
    
    &::-webkit-scrollbar {
      height: 4px;
    }
  }

  .footer-btn {
    min-width: 70px;
    padding: 5px 12px !important;
    font-size: 13px !important;
  }
}

// 下载统计样式（保留但优化）
.download_count {
  height: 150px;
  padding: 5px;

  .title {
    font-size: 20px;
    font-weight: 700;
    color: #165dff;
    margin-bottom: 15px;
  }

  .count_wrap {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 16px;
    color: #000;

    .lable {
      font-weight: 600;
      margin-right: 20px;
    }

    .count {
      padding: 2px 12px;
      border-radius: 13px;
      font-size: 14px;
      color: #fff;
      background-color: #165dff;
      transition: all 0.2s ease;
    }
  }
}
</style>
